import UpdateErrorBoundaryImage from './UpdateErrorBoundary.png';
import { useStyles } from './UpdateErrorBoundary.styles';

export const UpdateErrorBoundary = () => {
  const styles = useStyles();
  return (
    <div css={styles.root}>
      <img css={styles.img} src={UpdateErrorBoundaryImage} alt="Please Update" />
    </div>
  );
};
